import React, { useState } from 'react';
import ContentCard from '../ContentCard';
import InformationCard from '../InformationCard'; // Assuming you've created this component as per previous instructions

const InformationWeCollect = () => {
    const [expandedCard, setExpandedCard] = useState(null); // State to track the currently expanded card

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedCard(isExpanded ? panel : null);
    };

    return (
        <div className='left-align'>

            <ContentCard
                title="What personal information do we gather when you visit our website?"
                content={
                    <>
                        <InformationCard
                            title="Information collected from the website"
                            summary="When you visit our website, we may collect certain personal information automatically from your device:"
                            details={
                                <>
                                    <ul style={{ marginLeft: '20px' }}>
                                        <li>Your IP Address assigned to your device on the internet.</li>
                                        <li>The category or type of device you are using to access the internet, such as a smartphone or laptop.</li>
                                        <li>The web browser software you use to access websites, like Google Chrome or Mozilla Firefox.</li>
                                        <li>An approximate location determined by analyzing your IP address, typically at the city or regional level.</li>
                                        <li>Additional technical details about your device and internet connection, including operating system and screen resolution.</li>
                                        <li>Basic information such as your name, company, position, and relationship to a person.</li>
                                        <li>If you use the contact form we will process your name and adress and any other information you provide.</li>
                                    </ul>
                                </>
                            }
                            expanded={expandedCard === 'panel1'}
                            onChange={handleAccordionChange('panel1')}
                        />
                    </>
                }
            />

            <ContentCard
                title="What personal information do we gather when you hire us?"
                content={
                    <InformationCard
                        title="The information we collect about you as a client"
                        summary="When you hire us as your counsel we process information about you:"
                        details={
                            <>
                                <ul style={{ marginLeft: '20px' }}>
                                    <li>Basic information such as your name, company, position, and relationship to a person.</li>
                                    <li>Contact information such as your postal address, email address and telephone number(s).</li>
                                    <li>Financial information, such as payment related information.</li>
                                    <li>Identification and background information provided by you or collected as part of our business acceptance process.</li>
                                    <li>Personal data as part of the materials provided in a matter.</li>
                                    <li>Any other personal information relating to you or other third parties which you may provide to us for the purpose of receiving our services.</li>
                                </ul>

                            </>
                        }
                        expanded={expandedCard === 'panel2'}
                        onChange={handleAccordionChange('panel2')}
                    />
                }
            />

<ContentCard
                title="What other information do we collect?"
                content={
                    <>
                        <InformationCard
                            title="Other information"
                            summary="Data provided to us during engagements or when preparing/administering engagements:"
                            details={
                                <>
                                    <ul style={{ marginLeft: '20px' }}>
                                        <li>Mainly, we collect personal data directly from the individuals involved.</li>
                                        <li>Sometimes, we receive information about individuals involved that is not provided directly by them.</li>
                                        <li>Occasionally, we supplement personal data by obtaining information from other sources, such as: (i) search results from generally available search engines and (ii) records from various sources.</li>
                                    </ul>
                                </>
                            }
                            expanded={expandedCard === 'panel3'}
                            onChange={handleAccordionChange('panel3')}
                        />
                    </>
                }
            />

        </div>
    );
};

export default InformationWeCollect;
